import { NumberedItem } from '../../ui-components/NumberedItem'
import { PowerPerformanceForms, KnowWhyAPIReponseType } from '../../../types/mutual-fund-detail.types'
import { toPascalCaseWithSpaces } from '../../../utils/utils'
import { BigLeafRank } from './BigLeafRank'
import { getScoreConfig, getTagFromPowerForm } from '../utils'
import { GradientStrip } from '../../ui-components/GradientStrip'
import { StripContent } from './StripContent'
import { formatScoreOfTotalSpeech } from './ScoreValue'

interface PowerRankSectionProps {
  knowWhyData: KnowWhyAPIReponseType
  isElite: boolean
  number: number
  isLastSection: boolean
}

export const PowerRankSection = ({
  knowWhyData,
  isElite,
  number,
  isLastSection
}: PowerRankSectionProps) => {
  const powerRank = knowWhyData?.powerPerformanceData?.powerRank ?? null
  const categoryCount = knowWhyData?.powerPerformanceData?.categoryCount ?? 0
  const powerForm = (knowWhyData?.powerPerformanceData?.powerRating ||
    PowerPerformanceForms.IN_FORM) as `${PowerPerformanceForms}`

  const tag = getTagFromPowerForm(powerForm)
  const category = toPascalCaseWithSpaces(knowWhyData?.category ?? '')
  const config = getScoreConfig(tag)
  const scoreSpeech = formatScoreOfTotalSpeech(isElite ? powerRank : null, categoryCount, !isElite, 'rank')
  const description = "Fund's overall rank vs others in same category"
  const accessibilityLabel = [
    `Power Rank in ${category}`,
    scoreSpeech,
    config.scoreLabel,
    description
  ].join(', ')

  return (
    <NumberedItem
      as='li'
      number={number}
      title={`Power Rank`}
      subtitle={`in ${category}`}
      borderBottom={!isLastSection}
      accessibilityLabel={accessibilityLabel}
    >
      <GradientStrip type={config.gradientStripType}>
        <StripContent
          tag={tag}
          isElite={isElite}
          customContent={
            <BigLeafRank isElite={isElite} powerRank={powerRank} categoryCount={categoryCount} powerForm={powerForm} />
          }
          description='Fund’s overall rank vs others in same <br /> category'
          descriptionClassName='pt-1'
        />
      </GradientStrip>
    </NumberedItem>
  )
}
